module.exports = __webpack_public_path__ + "img/mob-del.0fcaf5d2.svg";